const config = {
  userCallbackForView: function (id, adResponse) {
    // eslint-disable-next-line no-console
    console.log('view callback');
  },

  userClickHandlerForClick: function (id, adResponse) {
    // eslint-disable-next-line no-console
    console.log('click callback');
  },

  onError: function (error, id) {
    // eslint-disable-next-line no-console
    console.log('error callback');
  },

  ORG: 'MMT',
  AUTH_COOKIE_KEY: 'mmt-auth',
  mode: 'PROD',
  API_CALL: 'SINGLE'
};

export default config;
